import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as queryString from 'query-string';
import ReactMarkdown from 'react-markdown';
import { signInGoogle } from '../../actions';

class GoogleLoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
        };
    }

    componentDidMount() {
        this.setState({ mounted: true });
        const parsed = queryString.parse(this.props.location.search);
        this.props.signInGoogle(parsed.code);
    }

    render() {
        const { loading, error, user } = this.props.auth;
        const { mounted } = this.state;
        return (
            <div>
                {mounted && (
                    <div className="container">
                        {loading
                            ? (
                                <div>
                                    Signing in...
                                </div>
                            )
                            : (
                                <div>
                                    {error && <div><ReactMarkdown>{`There was an error signing you in: ${error}`}</ReactMarkdown></div>}
                                    {user && <Redirect to={this.state.sourcePath || '/home'} />}
                                </div>
                            )}
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps({ auth }) {
    return { auth };
}

function mapDispatchToProps(dispatch) {
    return {
        signInGoogle: (code) => dispatch(signInGoogle(code)),
    };
}

const connectedComponent = connect(mapStateToProps, mapDispatchToProps)(GoogleLoginPage);

export default {
    component: withRouter(connectedComponent),
};
